/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import { useIndicationRecommendations } from './api/indicationRecsApi'
import { fetchAscanCsv, fetchCscanCsv } from './api/indicationSignalApi'
import {
  EMPTY_INDICATION_SET,
  entryToIndication,
  entryToIndicationSet,
  IndicationClassification,
  IndicationItem,
  IndicationItemWithClassification,
  IndicationModes,
  IndicationSet,
  IndicationSetType,
  IndicationStats,
  IndicationStatsJson,
  indicationToEntry,
  RD_TYPE_INDICATION,
  RD_TYPE_INDICATION_SET,
  RolodexIndication,
  useIndicationSets,
} from './api/indicationTriageApi'
import { calculateDamageArea } from './cards/damageCategory/categorizationFunctions'
import { DamageCategoryAutoGenCard } from './cards/damageCategory/DamageCategoryAutoGenCard'
import { ExpectedValueFromDamageAreas } from './cards/damageCategory/ExpectedValueFromDamageAreas'
import {
  nullableJsonToGeckoMeasurement,
  RESULT_OUTCOME_COLORS,
  RESULT_OUTCOME_LABELS,
} from './cards/ffsCalc/ffsResultPublish/ffsLtaPublishApi'
import {
  FfsPart,
  FfsResultType,
} from './cards/ffsCalc/ffsResultPublish/ffsTypes'
import { FfsLtaReport } from './cards/ffsCalc/ffsStrategyContext/ffsReports'
import {
  FFS_RESULT_CASES_PART_4,
  FFS_RESULT_CASES_PART_5,
  FfsAnalysisResult,
  FfsPartFiveResultIds,
  FfsPartFourResultIds,
  INDETERMINATE_FFS_RESULT_ID,
} from './cards/ffsCalc/ffsStrategyContext/ffsResultScenarios'
import { useDebouncedLoading } from './cards/ffsCalc/useDebouncedLoading'
import { UNKNOWN_COLOR_SCHEME } from './classification/indicationClassificationColors'
import {
  IndicationClassificationConfigVisualizer,
  IndicationClassificationConfigVisualizerProps,
} from './classification/IndicationClassificationConfigVisualizer'
import {
  BlankIndicationClassificationTag,
  createClassificationAntConfig,
  createClassificationCheckableTagStyle,
  IndicationClassificationTag,
} from './classification/IndicationClassificationTag'
import {
  createClassificationIndicationConfigContextValue,
  DEFAULT_CLASSIFICATION_CONFIG,
  DEFAULT_CLASSIFICATION_ORDERING,
  IndicationClassificationConfig,
  IndicationClassificationConfigContext,
  IndicationClassificationConfigContextType,
  useClassifyIndications,
} from './classification/indicationClassifier'
import { FfsStats, parseFfsStats } from './customInfoTypes/ffsStats'
import {
  DRA_SUB_MAPPINGS,
  GeckoDRA,
  GeckoSubDRA,
  rautReportCustomInfoCast,
  RautReportIndication,
  RautReportInfo,
  SUB_DRA_MAPPINGS,
} from './customInfoTypes/rautReport'
import {
  IndicationContext,
  IndicationContextType,
  RolodexIndicationContextProvider,
  useIndicationData,
} from './IndicationContext'
import {
  IndicationDetailCardExtensionContext,
  IndicationDetailCardExtensionProvider,
  useIndicationDetailCardExtension,
} from './IndicationDetailCardExtensionContext'
import { ToggledIndicationDetailView } from './IndicationDetailCardView'
import { IndicationTriageList } from './indicationTriageList/IndicationTriageList'
import { IndicationTriageHighlightType } from './indicationTriageList/IndicationTriageListRow'
import {
  UpdateIndicationContext,
  useUpdateIndicationContext,
} from './updateIndicationContext'
import {
  DEFAULT_DETAIL_CARD_CONFIG,
  IndicationCardsSwr,
  IndicationDetailCardGroup,
  IndicationDetailCardLeaf,
  IndicationDetailCardProps,
  LoadedIndicationDetailCard,
  useIndicationCards,
} from './useIndicationDetailCards'
import { useRolodexSyncIndications } from './useRolodexSyncIndications'

export {
  BlankIndicationClassificationTag,
  calculateDamageArea,
  createClassificationAntConfig,
  createClassificationCheckableTagStyle,
  createClassificationIndicationConfigContextValue,
  DamageCategoryAutoGenCard,
  DEFAULT_CLASSIFICATION_CONFIG,
  DEFAULT_CLASSIFICATION_ORDERING,
  DEFAULT_DETAIL_CARD_CONFIG,
  DRA_SUB_MAPPINGS,
  EMPTY_INDICATION_SET,
  entryToIndication,
  entryToIndicationSet,
  ExpectedValueFromDamageAreas,
  fetchAscanCsv,
  fetchCscanCsv,
  FFS_RESULT_CASES_PART_4,
  FFS_RESULT_CASES_PART_5,
  type FfsAnalysisResult,
  type FfsLtaReport,
  FfsPart,
  FfsPartFiveResultIds,
  FfsPartFourResultIds,
  FfsResultType,
  type FfsStats,
  GeckoDRA,
  GeckoSubDRA,
  INDETERMINATE_FFS_RESULT_ID,
  type IndicationCardsSwr,
  type IndicationClassification,
  type IndicationClassificationConfig,
  IndicationClassificationConfigContext,
  type IndicationClassificationConfigContextType,
  IndicationClassificationConfigVisualizer,
  type IndicationClassificationConfigVisualizerProps,
  IndicationClassificationTag,
  IndicationContext,
  type IndicationContextType,
  type IndicationDetailCardExtensionContext,
  IndicationDetailCardExtensionProvider,
  type IndicationDetailCardGroup,
  type IndicationDetailCardLeaf,
  type IndicationDetailCardProps,
  type IndicationItem,
  type IndicationItemWithClassification,
  IndicationModes,
  type IndicationSet,
  type IndicationSetType,
  type IndicationStats,
  type IndicationStatsJson,
  indicationToEntry,
  type IndicationTriageHighlightType,
  IndicationTriageList,
  type LoadedIndicationDetailCard,
  nullableJsonToGeckoMeasurement,
  parseFfsStats,
  rautReportCustomInfoCast,
  type RautReportIndication,
  type RautReportInfo,
  RD_TYPE_INDICATION,
  RD_TYPE_INDICATION_SET,
  RESULT_OUTCOME_COLORS,
  RESULT_OUTCOME_LABELS,
  type RolodexIndication,
  RolodexIndicationContextProvider,
  SUB_DRA_MAPPINGS,
  ToggledIndicationDetailView,
  UNKNOWN_COLOR_SCHEME,
  UpdateIndicationContext,
  useClassifyIndications,
  useDebouncedLoading,
  useIndicationCards,
  useIndicationData,
  useIndicationDetailCardExtension,
  useIndicationRecommendations,
  useIndicationSets,
  useRolodexSyncIndications,
  useUpdateIndicationContext,
}
